import { useTranslation } from 'react-i18next';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/Select';
import { SUPPORTED_LANGUAGES } from '@/lib/i18n';

export function LanguageSelector() {
  const { t, i18n } = useTranslation('translation', {
    keyPrefix: 'components.LanguageSelector',
  });

  function handleChangeLanguage(language: string) {
    localStorage.setItem('i18nextLng', language);
    window.location.reload();
  }

  return (
    <Select value={i18n.language} onValueChange={handleChangeLanguage}>
      <SelectTrigger className="w-full max-w-xs">
        <SelectValue placeholder={t('placeholder')} />
      </SelectTrigger>

      <SelectContent>
        {SUPPORTED_LANGUAGES.map((language) => (
          <SelectItem key={language.value} value={language.value}>
            <div className="flex items-center gap-2">
              <span>{language.flag}</span>
              <span>{language.label}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
